import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import {
  updateGeneralConfiguration,
  updateNoiseDoseConfiguration,
  updateTemperatureConfiguration,
  updateLightingConfiguration,
} from "@/api";
import { CONFIGURATION_QUERY_KEY } from "@/lib/constants";
import {
  GeneralConfigurationRequest,
  NoiseDoseConfigurationRequest,
  TemperatureConfigurationRequest,
  LightingConfigurationRequest,
} from "@/api/update-configuration";

export function useUpdateGeneralConfiguration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (configuration: GeneralConfigurationRequest) => {
      const result = await updateGeneralConfiguration(configuration);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al actualizar configuración", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      queryClient.invalidateQueries({ queryKey: [CONFIGURATION_QUERY_KEY] });

      toast.success("Configuración actualizada exitosamente", {
        description: result.val,
      });
      return result.val;
    },
  });
}

export function useUpdateNoiseDoseConfiguration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (configuration: NoiseDoseConfigurationRequest) => {
      const result = await updateNoiseDoseConfiguration(configuration);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al actualizar configuración", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      queryClient.invalidateQueries({ queryKey: [CONFIGURATION_QUERY_KEY] });

      toast.success("Configuración actualizada exitosamente", {
        description: result.val,
      });
      return result.val;
    },
  });
}

export function useUpdateTemperatureConfiguration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (configuration: TemperatureConfigurationRequest) => {
      const result = await updateTemperatureConfiguration(configuration);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al actualizar configuración", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      queryClient.invalidateQueries({ queryKey: [CONFIGURATION_QUERY_KEY] });

      toast.success("Configuración actualizada exitosamente", {
        description: result.val,
      });
      return result.val;
    },
  });
}

export function useUpdateLightingConfiguration() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (configuration: LightingConfigurationRequest) => {
      const result = await updateLightingConfiguration(configuration);
      if (result.err) {
        console.error(result.val.devMessage);
        toast.error("Error al actualizar configuración", {
          description: result.val.message,
        });
        throw new Error(result.val.message);
      }

      queryClient.invalidateQueries({ queryKey: [CONFIGURATION_QUERY_KEY] });

      toast.success("Configuración actualizada exitosamente", {
        description: result.val,
      });
      return result.val;
    },
  });
}
